angular.module('unergie.main')
.directive('leftMenu', ($rootScope, $state, $timeout, $uibModal, $interval, BoFeaturesService, ReferencesService, AuthService, Technical) =>
    ({
        restrict: 'E',
        templateUrl: '/states/home/component/leftMenu.html',
        scope: {
            collapsed: '=isCollapsed',
            onToggleCollapse: '&',
        },
        link($scope) {
            $scope.state = $state
            $scope.menuToggleState = JSON.parse(_.defaultTo(localStorage.menuToggleState, '{}'))
            $scope.envLabel = 'Loading...'
            $scope.envShortLabel = '...'
            $scope.envStyle = {}
            $scope.menuTerm = { current: '', old: '' }
            $scope.browserVersion = '1749803655283'
            $scope.versionWarning = false
            $scope.versionWarningMessage = 'La version du backoffice a été mise à jour, rafraichissez la page ou cliquez. ' +
          'Si le message persiste, videz le cache (ctrl + F5), ou relancez votre navigateur.'

            // ng-if
            $scope.showTools = !BoFeaturesService.get('isEnvProd')
            $scope.canFilterMenu = BoFeaturesService.isFeatureOn('canFilterMenu')

            // Filter on submenus.label
            const filterMenuOnSubmenuLabel = _.memoize((term, menus) => _.flow(
                (menuList) => _.map(menuList, (menu) => _.assign({}, menu, { submenus: _.filter(menu.submenus, (submenu) => new RegExp(term, 'i').exec(submenu.label)) })),
                (menuList) => _.filter(menuList, (menu) => !_.isEmpty(menu.submenus))
            )(menus))

            const setMenuToggleState = (menus) => {
                const isMenuTermChangedToDefined = !!$scope.menuTerm.old === false && !!$scope.menuTerm.value === true
                const isMenuTermChangedToUndefined = !!$scope.menuTerm.old === true && !!$scope.menuTerm.value === false
                if (isMenuTermChangedToDefined) {
                    // set menuToggle to localstorage and open all menu
                    localStorage.menuToggleState = JSON.stringify($scope.menuToggleState)
                    $scope.menuToggleState = _.fromPairs(_.map(menus, (menu) => [menu.label, true]))
                } else if (isMenuTermChangedToUndefined) {
                    // set menuToggle from localstorage or close all menu
                    $scope.menuToggleState = JSON.parse(localStorage.menuToggleState) || _.fromPairs(_.map(menus, (menu) => [menu.label, false]))
                }
                $scope.menuTerm.old = $scope.menuTerm.value
            }

            $scope.menus = () => {
                const menus = $scope.menuTerm.value ? filterMenuOnSubmenuLabel($scope.menuTerm.value, AuthService.getMenus()) : AuthService.getMenus()
                setMenuToggleState(menus)
                return menus
            }

            $scope.toggleSubmenu = function (key) {
                let newToggleState = true
                if ($scope.collapsed) {
                    $scope.onToggleCollapse()
                } else {
                    newToggleState = !_.get($scope.menuToggleState, key, false)
                }
                $scope.menuToggleState[key] = newToggleState
                if (!$scope.menuTerm.value) {
                    localStorage.menuToggleState = JSON.stringify($scope.menuToggleState)
                }
            }

            $scope.isActive = (state) => $state.is(state)

            $scope.evaluate = (param) => (param ? $scope[param] : true)

            const checkVersion = () =>
                Technical.checkVersion().$promise.then((result) => {
                    const resultVersion = Number(result.version)
                    const browserVersion = Number($scope.browserVersion)
                    $scope.versionWarning = browserVersion < resultVersion
                    $scope.envStyle['version-warning'] = $scope.versionWarning
                    if ($scope.versionWarning) {
                        $rootScope.displayVersionBand = true
                        return console.log(`Versions mismatch - Browser version: ${browserVersion}, Current version: ${resultVersion}`)
                    }
                })

            const activate = function () {
                BoFeaturesService.getFeatures().then((features) => {
                    if (features) {
                        const envLabels = features.styles
                        $scope.companyLogo = envLabels.companyLogo
                        const env = BoFeaturesService.getEnv()
                        const envType = env && env.split('-').pop()
                        $scope.envClassLabel = _.get(envLabels, [envType, 'style'], 'Development')
                        $scope.envLabel = _.get(envLabels, [envType, 'label'], 'Development')
                        $scope.envShortLabel = _.get(envLabels, [envType, 'shortLabel'], 'Development')
                        $scope.envStyle[_.get(envLabels, [envType, 'style'], 'devel')] = true
                        $('#dynamic-favicon').attr('href', `/images/assets/img/${_.get(envLabels, `${envType}.favicon`, `favicon_${env}.png`)}`)
                    }
                })

                checkVersion()
                return $interval(checkVersion, 60000)
            }

            $scope.applyEnvClass = (className) => {
                if ($scope.envClassLabel) {
                    const versionWarning = $scope.versionWarning && className === 'env-label' ? 'version-warning' : ''
                    return `${className}--${$scope.envClassLabel} ${versionWarning}`
                }
            }

            return activate()
        },
    })
)
